const EXTERNAL_ICON_PATH = '/admin/assets/libs/school360/images/externalIcons/' ;
const S360_ICON_PATH = '/admin/assets/libs/school360/images/' ;
const S360_HOME =  'index.php';

export const EXTERNAL_icons = {
    GMAIL: EXTERNAL_ICON_PATH + 'gmail.svg',
    DRIVE: EXTERNAL_ICON_PATH + 'drive.svg',
    CALENDAR: EXTERNAL_ICON_PATH + 'calendar.svg',
    CLASSROOM: EXTERNAL_ICON_PATH + 'classroom.svg',
    ESCHOOLS: EXTERNAL_ICON_PATH + 'eschools.png',
    ONLINE_SAFETY: EXTERNAL_ICON_PATH + 'online_safety.png',
    DISCUSS: EXTERNAL_ICON_PATH + 'discuss.png',
    SITES: EXTERNAL_ICON_PATH + 'sites.png',
    NOTES: EXTERNAL_ICON_PATH + 'keep.png'
}

export const S360_icons = {
    S360_LOGO: S360_ICON_PATH + '360logo.svg',
    JOURNAL: S360_ICON_PATH + 'journal.svg',
    PROGRESS: S360_ICON_PATH + 'progress.svg',
    PARENT: S360_ICON_PATH + 'parent_obs.svg',
}

export const S360_urls = {
    GMAIL_URL: 'https://mail.google.com/a/school360.co.uk',
    DRIVE_URL: 'https://drive.google.com/a/school360.co.uk/#my-drive',
    CALENDAR_URL: 'https://calendar.google.com/a/school360.co.uk',
    CLASSROOM_URL: 'https://calendar.google.com/a/school360.co.uk',
    REGISTER_CLASS_URL: '?page=react_form_registration&class_id=null&session=null',
    REGISTRATION_REPORT_URL: 'eyfs_admin.php?lang=en&page=form_regReports_filter_n&report=LatePupils',
    CONCERN_REPORTS_URL: 'eyfs_admin.php?lang=en&page=react_form_concern_reports',
    DASHBOARDS_URL: 'eyfs_admin.php?lang=en&page=react_form_dashboards',
    MY_PUPILS_URL: 'eyfs_admin.php?page=eyfsChildren_n&user_type=2&menu=4',
    CREATE_RESOURCE_URL: 'eyfs_admin.php?page=form_resources_n&menu=3&mode=create',
    CREATE_SETTING_URL: 'eyfs_admin.php?page=EYFSSchoolAdmin_n&mode=create',
    MY_ACCOUNT_URL: 'eyfs_admin.php?lang=en&page=EYFSUserAdmin_n3&mode=edit&me=true',
    TEACHER_HOME_URL: '/classview/index.php',
    SI_ALL_SCHOOLS_SHARED_DRIVE: 'https://drive.google.com/a/school360.co.uk/?urp=https://school360.co.uk/index.php?lang%3Den%26page%3Ddat#folders/0B0xqk4hYOj1cWF9DcTRxNDJEbDA',
    SI_ALL_SIP_SHARED_DRIVE: 'https://drive.google.com/a/school360.co.uk/?urp=https://school360.co.uk/index.php?lang%3Den%26page%3Ddat#folders/0B0xqk4hYOj1ca3AzbzlIVTlOQUk',
    TRAINING_GUIDE_URL: 'https://www.canva.com/design/DAGJDbcqkDE/FlXXC9It7_-UXupeuj3WRg/view?utm_content=DAGJDbcqkDE&utm_campaign=designshare&utm_medium=link&utm_source=editor#1',
    ONLINE_SAFETY_URL: 'https://sites.google.com/school360.co.uk/online-safety-support/home',
    DISCUSS: 'https://groups.google.com/a/school360.co.uk',
    SITES: 'https://accounts.google.com/a/school360.co.uk/ServiceLogin?passive=1209600&continue=https://sites.google.com/a/school360.co.uk&followup=https://sites.google.com/a/school360.co.uk',
    NOTES: 'https://keep.google.com/a/school360.co.uk'
}

export const S360_charts = {
    RESOURCE_USAGE_BY_MONTH: 0,
    RESOURCE_USAGE_TOTALS: 1,
    S360_USAGE_BY_MONTH: 2,
    S360_USAGE_TOTALS: 3,
    RESOURCE_USAGE_BY_SCHOOL: 4
}

export const GRAPH_COLORS = {
    GRAPH_COLOR_1: '#9372fc',//'#718DCE',
    GRAPH_COLOR_2: '#CC0505',
    GRAPH_COLOR_3: '#FFC79A',
    GRAPH_COLOR_4: '#b8f5b8',
    GRAPH_COLOR_5: '#fa9d23',
    GRAPH_COLOR_6: '#1241AA',
    GRAPH_COLOR_7: '#04CE03',
    GRAPH_COLOR_8: '#7309AE',//'#A2B4DE',
    GRAPH_COLOR_9: '#dbd402',
    GRAPH_COLOR_10: '#E267AC',//'#4266BE',
    GRAPH_COLOR_11: '#b5c8f5',
    GRAPH_COLOR_12: '#024cf7',
    GRAPH_COLOR_13: '#5d5e5e',
    GRAPH_COLOR_14: '#a38967',
    GRAPH_COLOR_15: '#00999A',
    GRAPH_COLOR_16: '#68C2C6'//'#FF9135'
}